import { t } from "@/i18n-js/instance";
import { Icon } from "@/react/components/shared/Icon";
import {
  Dropdown,
  useDropdownContext,
} from "@/react/components/shared/uikit/Dropdown";
import { Typography } from "@/react/components/shared/uikit/Typography";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { Button } from "@circle-react-uikit/Button";

export const ContentFilterButton = ({
  selectedTemplateType,
  translationKey,
}: {
  selectedTemplateType: string;
  translationKey: string;
}) => {
  const { isOpen } = useDropdownContext();

  return (
    <Dropdown.MenuButton className="!justify-start">
      <Button
        small
        variant="secondary-light"
        className={classNames("!border-dark flex gap-1 !py-2", {
          "!bg-tertiary": isOpen,
        })}
      >
        <Typography.LabelXs>{`${t([translationKey, "title"])}:`}</Typography.LabelXs>
        <Typography.LabelXs weight="medium">
          {t([translationKey, selectedTemplateType])}
        </Typography.LabelXs>
        <Icon type="16-chevron-down" size={16} />
      </Button>
    </Dropdown.MenuButton>
  );
};
